import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

// location.key is "default" only for the entry the tab was opened on, so any other key means
// there is an in-app page to return to; otherwise (deep link, new tab) fall back to the landing.
// `inline` renders the bare button for screens that place it next to their page icon.
export function PublicBackButton({ inline = false }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== "default";
  const label = hasHistory ? t("public_back") : t("public_back_home");

  const button = (
    <button
      type="button"
      className="public-back-btn"
      onClick={() => (hasHistory ? navigate(-1) : navigate("/"))}
      aria-label={label}
      data-testid="public-back-btn"
    >
      <ArrowLeft size={16} aria-hidden />
      <span className="public-back-label">{label}</span>
    </button>
  );

  return inline ? button : <div className="public-back-row">{button}</div>;
}

// Docs and guide screens place the button next to their own page icon; every other
// existing guest page gets it as a row above the content. Unknown paths (404) get none.
export function PublicBackLayout() {
  const { pathname } = useLocation();
  const nextToIcon = pathname.startsWith("/docs") || pathname.startsWith("/guides");
  return (
    <>
      {nextToIcon ? null : <PublicBackButton />}
      <Outlet />
    </>
  );
}
